// extracted by mini-css-extract-plugin
export default {"socialLink":"style--socialLink--75b277","socialDomain":"style--socialDomain--5ab23f","facebookIcon":"style--facebookIcon--545965","twitterIcon":"style--twitterIcon--0e010f"};